import { Routes } from '@angular/router';

/**
 * Maintenance detail routes — single-page layout (no inner tabs).
 *
 * The page lives at the parent route. The legacy `/overview`, `/status`,
 * `/documents`, `/notes` and `/requests` sub-paths are kept as redirects so
 * existing bookmarks and notifications still resolve.
 */
export const maintenanceDetailRoutes: Routes = [
  { path: '', pathMatch: 'full', children: [] },
  { path: 'overview', redirectTo: '', pathMatch: 'full' },
  { path: 'status', redirectTo: '', pathMatch: 'full' },
  { path: 'documents', redirectTo: '', pathMatch: 'full' },
  { path: 'notes', redirectTo: '', pathMatch: 'full' },
  { path: 'requests', redirectTo: '', pathMatch: 'full' }
];
